import {Component, Input} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'form-field-date',
  templateUrl: 'form-field-date.component.html',
  styleUrls: ['form-field-date.component.scss']
})
export class FormFieldDateComponent {
  @Input() field!: any;
  @Input() formGroup!: FormGroup;

  constructor() {
  }

  ngOnInit() {

  }


}
